import { EU_LAENDER } from '../constants/laender';
import { Steuerfall } from '../types';

export const STEUERFALL_OPTIONEN: { value: Steuerfall; label: string }[] = [
  { value: 'inland', label: 'Inland (19 % USt)' },
  { value: 'eu_reverse_charge', label: 'EU Reverse Charge (0 %)' },
  { value: 'eu_ohne_ustid', label: 'EU ohne USt-ID (19 % USt)' },
  { value: 'drittland', label: 'Drittland, nicht steuerbar (0 %)' },
];

export function steuersatzFuer(steuerfall: Steuerfall | undefined | null): number {
  if (steuerfall === 'eu_reverse_charge' || steuerfall === 'drittland') {
    return 0;
  }
  return 19;
}

export function vorschlageSteuerfall(land?: string | null, ustId?: string | null): Steuerfall {
  const code = (land || 'DE').toUpperCase().slice(0, 2);
  const ust = (ustId || '').replace(/\s/g, '');
  if (code === 'DE') {
    return 'inland';
  }
  if (EU_LAENDER.has(code)) {
    return ust ? 'eu_reverse_charge' : 'eu_ohne_ustid';
  }
  return 'drittland';
}

export function steuerfallHinweis(steuerfall: Steuerfall | undefined | null): string | null {
  if (steuerfall === 'eu_ohne_ustid') {
    return 'Ohne USt-ID des Empfängers ist Reverse Charge nicht möglich. Es wird der deutsche Regelsteuersatz berechnet.';
  }
  return null;
}
